<template lang="html">
  <section class="wrapper">
    <template  v-if="!$route.meta.hidden || $route.name === 'reset'">
      <template v-if="$auth.ready()">
        <header class="header">
          <router-link class="logo" :to="{path: '/'}">
            <img
              alt="Hamlet"
              src="./assets/logo.svg"
              height="32px;"
            >
          </router-link>
          <el-row class="user-info">
            <el-dropdown trigger="click">
              <span class="el-dropdown-link">
                <span class="avatar"><i class="iconfont icon-user"></i></span>
                <span>{{$auth.user().username}}</span>
                <i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown" class="db-dropdown">
                <el-dropdown-item @click.native="resetPassword">
                  <i class="iconfont icon-user-tie el-icon--left"></i>
                  {{ $t('common.resetPassword') }}
                </el-dropdown-item>
                <el-dropdown-item @click.native="logout">
                  <i class="iconfont icon-exit el-icon--left"></i>
                  {{ $t('common.logout') }}
                </el-dropdown-item>
                <el-dropdown-item
                  v-if="!$auth.user().thirdparty_users.weixin"
                  @click.native="loginByWeixin"
                >
                  <i class="iconfont icon-exit el-icon--left"></i>
                  {{ $t('common.bound_weixin') }}
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </el-row>
        </header>

        <el-row class="container">
          <aside class="menu-wrapper">
            <el-menu :default-active="activeMenu" class="el-menu-vertical" theme="dark" router unique-opened>
              <template v-for="(route, index) in $router.options.routes[1].children">
                <el-menu-item
                  v-if="!route.meta.hidden  && roleShow(route)"
                  :index="route.name"
                  :route="route"
                  :class="{'is-active': route.name === activeMenu || route.name === 'applications' && $route.name === 'app_manage'}"
                >
                  {{ $t(`menu.${route.name}`) }}
                </el-menu-item>
              </template>
            </el-menu>
          </aside>

          <el-row class="content">
            <router-view></router-view>
          </el-row>
        </el-row>
      </template>
    </template>
    <router-view v-else />
  </section>
</template>

<script>
export default {
  data() {
    return {
      name: 'app',
      weixinParam: {
        app_key: 'qZkZT5WZSdirdcL88wyRx5pN8tsyaqAi',
        return_url: 'http://hamlet.yimian.com.cn/apps',
      },
    };
  },
  computed: {
    activeMenu() {
      return this.$route.name;
    },
  },
  methods: {
    resetPassword() {
      this.$router.push({ name: 'reset' });
    },
    logout() {
      this.$http.post('/api/auth/logout').then((res) => {
        if (res.body.ok) {
          this.$auth.logout().then(() => {
            this.$router.push({ name: 'login' });
          });
        }
      });
    },
    roleShow(route) {
      return route.meta.auth.indexOf(this.$auth.user().role) !== -1;
    },
    loginByWeixin() {
      this.weixinParam.return_url = `http://hamlet.yimian.com.cn${this.$route.path}`;
      this.$api.loginByWeixin(this.weixinParam)
        .then((res) => {
          window.location = res.data.url;
        })
        .catch((res) => {
          this.$message.error(res.data.data);
        });
    },
  },
};
</script>

<style lang="scss">
  @import "./assets/font/iconfont.css";
</style>



// WEBPACK FOOTER //
// App.vue?439a3872